// Imports
import axios from 'axios';

// App imports
import { URL_API } from '../../../../../setup/config/env';

// Profile
export default function userIssues(projectId, refreshToken) {
  return axios.get(`${URL_API}/gitlab/allIssues`, {
    params: { id: projectId, token: refreshToken },
  });
}
